import { memo } from 'react';
import styled from 'styled-components';
import { ComponentRepresentation } from '@ardoq/basic-components';
import {
  CheckboxIcon,
  CheckboxUnsetIcon,
  CheckboxCheckedIcon,
} from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { TextOverflow } from '@ardoq/popovers';
import { HoverPreviewRowProps } from '../../components/PropTypes';
import { SelectItemContainer } from '../../components/Atoms';
import { NodeExpander } from '../../components/NodeExpander';

const ComponentContainer = styled(FlexBox)`
  line-height: 30px;
  height: 30px;
  transition:
    background-color 0.3s,
    opacity 0.3s;
  align-items: center;
`;

const CheckboxDisabled = styled(CheckboxUnsetIcon)`
  opacity: 0.5;
`;

const CheckboxCheckedDisabled = styled(CheckboxCheckedIcon)`
  opacity: 0.5;
`;

const SelectComponentItem = memo(
  ({
    name,
    containerStyle,
    containerClassNames,
    componentRepresentationData,
    iconWrapperClassNames,
    iconWrapperStyle,
    nodeId,
    hasVisibleContent,
    isExpanded,
    isSelected,
    isSelectable,
    isDisabledOption,
    ariaAttributes,
    triggerProps,
    detailsId,
  }: HoverPreviewRowProps) => {
    return (
      <SelectItemContainer
        {...triggerProps}
        data-id={nodeId}
        className={containerClassNames}
      >
        <ComponentContainer
          style={containerStyle}
          role="treeitem"
          {...ariaAttributes}
          aria-details={detailsId}
        >
          <NodeExpander
            hasVisibleContent={hasVisibleContent}
            isExpanded={isExpanded}
            name={name}
          />
          {isDisabledOption ? (
            <CheckboxCheckedDisabled />
          ) : isSelectable ? (
            <CheckboxIcon checked={isSelected} />
          ) : (
            <CheckboxDisabled />
          )}
          <span className={iconWrapperClassNames} style={iconWrapperStyle}>
            {componentRepresentationData && (
              <ComponentRepresentation
                isImage={componentRepresentationData.isImage}
                value={componentRepresentationData.value}
                icon={componentRepresentationData.icon}
              />
            )}
          </span>
          <TextOverflow
            role="button"
            className="component-name component"
            popoverAcceptsMouse={false}
            renderIn={triggerProps ? null : 'popover'}
          >
            {name}
          </TextOverflow>
        </ComponentContainer>
      </SelectItemContainer>
    );
  }
);

export { SelectComponentItem };
